import { render, staticRenderFns } from "./RgsListItem.vue?vue&type=template&id=b3965230&"
import script from "./RgsListItem.vue?vue&type=script&lang=ts&"
export * from "./RgsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports